/** URLs identify a discussion; server-side membership checks authorize access. */
export function privateDiscussionLocation(search: string) {
  const params = new URLSearchParams(search)
  const workspace = params.get('workspace') ?? ''
  const thread = params.get('thread') ?? ''
  return {
    workspace: /^[a-z0-9][a-z0-9-]{0,79}$/.test(workspace) ? workspace : undefined,
    thread: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(thread) ? thread : undefined,
  }
}

export function privateDiscussionHref(path: string, workspace: string, thread?: string) {
  return `${path}?${new URLSearchParams({workspace, ...(thread ? {thread} : {})})}`
}
